import { useState } from "react"
import { Button } from "@/components/ui/button"
import { ChevronRight, ChevronDown } from "lucide-react"
import { CategoryDto } from "@/api/api-client"
import { useLanguage } from "@/hooks/useLanguage"
import { cn } from "@/lib/utils"

interface CategoryFilterItemProps {
  cat: CategoryDto
  selectedId: number | null
  onSelect: (id: number | null) => void
  depth?: number
  language?: "es" | "en"
}

export const CategoryFilterItem = ({
  cat,
  selectedId,
  onSelect,
  depth = 0,
}: CategoryFilterItemProps) => {
  const { language } = useLanguage()
  const [isOpen, setIsOpen] = useState(depth < 1)
  const isSelected = selectedId === cat.id
  const hasSub = cat.subcategories && cat.subcategories.length > 0

  return (
    <div className="space-y-1">
      <div className="group flex items-center gap-1">
        {hasSub ? (
          <Button
            variant="ghost"
            size="icon"
            className="h-5 w-5 p-0"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
          </Button>
        ) : (
          <div className="w-5" />
        )}
        <Button
          variant="ghost"
          size="sm"
          className={cn(
            "h-8 flex-1 justify-between rounded-none px-3 text-sm transition-colors",
            isSelected ? "bg-primary/80 font-black text-white dark:bg-primary/90" : "font-bold text-muted-foreground hover:bg-primary/10 hover:text-foreground dark:hover:bg-primary/20"
          )}
          onClick={() => onSelect(cat.id)}
        >
          {language === "es" ? cat.nameEs : cat.nameEn}
          <ChevronRight className={cn("h-4 w-4", isSelected ? "text-white" : "text-muted-foreground/50")} />
        </Button>
      </div>

      {hasSub && isOpen && (
        <div className="ml-4 space-y-1 border-l pl-1">
          {cat.subcategories!.map((sub) => (
            <CategoryFilterItem
              key={sub.id}
              cat={sub}
              selectedId={selectedId}
              onSelect={onSelect}
              depth={depth + 1}
            />
          ))}
        </div>
      )}
    </div>
  )
}

